<template>
  <homepageLoading v-if="$apollo.loading" />

  <v-app id="home-page" v-else>
    <offer />
    <!-- <banner :imgSrc="require('../assets/header.jpeg')" /> -->
    <carousal :images="images"> </carousal>
    <categories
      :genders="filters.genders"
      :categories="filters.categories"
      class="pl-md-16"
    />

    <!-- <brands :brands="filters.brands" class="pl-md-16" /> -->

    <div class="pl-md-16 my-5">
      <p class="text-h4 font-weight-bold pl-2 py-4">New Arrival</p>
      <productsGrid :productChunks="newArrivals"></productsGrid>
    </div>

    <div class="pl-md-16 my-5">
      <p class="text-h4 font-weight-bold pl-2 py-4">Best Sellers</p>
      <productsGrid :productChunks="bestsellers"></productsGrid>
    </div>

    <div class="pl-md-16 my-5">
      <p class="text-h4 font-weight-bold pl-2 py-4">Flash Sale</p>
      <productsGrid :productChunks="flashsale"></productsGrid>
    </div>

    <div class="pl-md-16 my-5">
      <p class="text-h4 font-weight-bold pl-2 py-4">Best Combos</p>
      <productsGrid :productChunks="combos"></productsGrid>
    </div>

    <!-- <v-container>
             <p class="text-h4 pl-2 py-4"> Trending Now  </p>
             <productsGrid :productChunks="productChunks"></productsGrid> 
             
        </v-container>

        <v-container>
             <p class="text-h4 pl-2 py-4"> Femine fashion you wont miss   </p>
             <productsGrid :productChunks="productChunks"></productsGrid> 
             
        </v-container> -->
  </v-app>
</template>

<script>
//import navbar from './navbar.vue';
// import banner from "./home/banner.vue";
import categories from "./home/categoriesscroller.vue";
// import brands from "./home/brands.vue";
import productsGrid from "./products/productsGrid.vue";
import carousal from "./carousal.vue";
import offer from "./offer.vue";
import { LoadMainData } from "../graphql/Queries/homePage";
import { chunk } from "lodash";
import homepageLoading from "./home/loading.vue";
//let h = document.getElementById('nav').clientHeight;

export default {
  name: "homePage",
  components: {
    homepageLoading,
    // banner,
    categories,
    // brands,
    productsGrid,
    carousal,
    offer,
  },
  mounted() {
    // this.$store.dispatch("products/getProducts");
  },

  data: () => ({
    model: null,
    images: [
      {
        src: require("../assets/header.jpeg"),
        link: "/products/628a7412162e8663197f6e31",
      },
    ],
  }),

  computed: {
    bestsellers() {
      return chunk(this.BestSeller.products, 4);
    },
    newArrivals() {
      return chunk(this.NewArrivals.products, 4);
    },
    flashsale() {
      return chunk(this.FlashSale.products, 4);
    },
    combos() {
      return chunk(this.Combo.products, 4);
    },
  },
  apollo: {
    filters: { query: LoadMainData },
    categories: { query: LoadMainData },
    NewArrivals: { query: LoadMainData },
    BestSeller: { query: LoadMainData },
    FlashSale: { query: LoadMainData },
    Combo: { query: LoadMainData },
  },
};
</script>

<style scoped lang="css">
#home-page {
  background-color: #fdf8f5;
}
#cat {
  margin-top: 0%;
}
</style>
